import { Box, InputCheckBox } from "@itandi/itandi-bb-ui";
import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import type { DealSearchCondition, SearchApplicationType } from "~/models/Deal";

type Props = {
	applicationType: SearchApplicationType;
	label: string;
};

export function ApplicationTypeCheckBox({ applicationType, label }: Props) {
	const { setValue, watch, getValues } = useFormContext<DealSearchCondition>();
	const watchedApplicationTypes = watch("applicationTypes");
	const isChecked = watchedApplicationTypes?.includes(applicationType) ?? false;

	const onApplicationTypeChange = useCallback((): void => {
		const current = [...(getValues("applicationTypes") ?? [])];
		const index = current.indexOf(applicationType);

		if (index >= 0) {
			current.splice(index, 1);
		} else {
			current.push(applicationType);
		}

		setValue("applicationTypes", current);
	}, [applicationType, getValues, setValue]);

	return (
		<Box margin={4} minWidth={0}>
			<InputCheckBox
				checked={isChecked}
				label={label}
				onChange={onApplicationTypeChange}
			/>
		</Box>
	);
}
